import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { escapeDoubleQuotes, IsEmpty, secondToJsonLd } from "../../../util/commonFunctions";
import { MetaContent } from "../../../constants/constant";
import { analytics } from "../../../analytics";
import { getEnv } from "../../../../helpers/env";
import cosmeticConfig from "../../../../config/cosmeticConfig";
import MD5 from "crypto-js/md5";


const HelmetStructure = props => {
  const [pageUrl, setPageUrl] = useState("");
  function RemoveLastDirectoryPartOf(the_url) {
    var the_arr = the_url && the_url.split('/');
    if (the_arr) {
      the_arr.pop();
      return (the_arr.join('/'));
    }
  }
  
  useEffect(() => { // send User id to GTM
    setPageUrl(window.location.href);
    if (props.token && props.userProfile) {
      let salted_id = props.userProfile?.id + cosmeticConfig.global.SITE_SALT
      analytics("", {
        "userId": MD5(salted_id).toString()
      })
    }
  }, []);


  return (
    <Helmet>
      <title>
        {!IsEmpty(props.title) ? props.title : MetaContent.home.title}
      </title>
      {(props.canonicalUrl != null || props.canonicalUrl != undefined) && (
        <link rel="canonical" href={props.canonicalUrl} />
      )}
      {props.title != "false" && (
        <meta
          property="og:title"
          content={!IsEmpty(props.title) ? props.title : MetaContent.home.title}
        ></meta>
      )}
      {props.title != "false" && (
        <meta
          name="twitter:title"
          content={!IsEmpty(props.title) ? props.title : MetaContent.home.title}
        ></meta>
      )}
      {props.subject != "false" && (
        <meta
          name="subject"
          content={
            !IsEmpty(props.subject) ? props.subject : MetaContent.home.subject
          }
        />
      )}
      {props.description != "false" && (
        <meta
          name="description"
          content={
            !IsEmpty(props.description)
              ? props.description
              : MetaContent.home.description
          }
        />
      )}
      {props.description != "false" && (
        <meta
          property="og:description"
          content={
            !IsEmpty(props.description)
              ? props.description
              : MetaContent.home.description
          }
        />
      )}
      {props.description != "false" && (
        <meta
          name="twitter:description"
          content={
            !IsEmpty(props.description)
              ? props.description
              : MetaContent.home.description
          }
        />
      )}
      {props.keywords != "false" && (
        <meta
          name="keywords"
          content={
            !IsEmpty(props.keywords)
              ? props.keywords
              : MetaContent.home.keywords
          }
        />
      )}
      <meta
        property="og:image"
        content={
          !IsEmpty(props.thumbnailImage)
            ? props.thumbnailImage
            : MetaContent.home.thumbnailImage
        }
      />
      <meta
        name="image"
        property="og:image"
        content={
          !IsEmpty(props.thumbnailImage)
            ? props.thumbnailImage
            : MetaContent.home.thumbnailImage
        }
      ></meta>
      <meta
        name="twitter:image"
        content={
          !IsEmpty(props.thumbnailImage)
            ? props.thumbnailImage
            : MetaContent.home.thumbnailImage
        }
      ></meta>
      {props.noIndex == "true" && (
        <meta name="robots" content="nofollow"></meta>
      )}
      {props.noIndex == "true" && (
        <meta name="googlebot" content="noindex"></meta>
      )}

      {props.showLive &&
        props.data[0].data && props.slideNumber &&
        props.data[0].data[props.slideNumber] && (
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": "${escapeDoubleQuotes(props.data[0].data[props.slideNumber].show)}",
            "description": "${escapeDoubleQuotes(props.data[0].data[props.slideNumber].showSummary)}",
            "thumbnailUrl": "${MetaContent.home.thumbnailImage}",
            "uploadDate": "${new Date().toISOString()}",
            "regionsAllowed": "AU",
            "duration": "${secondToJsonLd(
                  props.data[0].data[props.slideNumber].startDateTime -
                  props.data[0].data[props.slideNumber].endDateTime
                )}",
            "contentUrl": "${props.videoUrl}",
            "embedUrl": "${RemoveLastDirectoryPartOf(props.videoUrl)}",
            "expires": "${new Date(props.data[0].data[props.slideNumber].endDateTime).toISOString()}",
            "publication": [{
              "@type": "BroadcastEvent",
              "isLiveBroadcast": true,
              "startDate": "${new Date(props.data[0].data[props.slideNumber].startDateTime).toISOString()}",
              "endDate": "${new Date(props.data[0].data[props.slideNumber].endDateTime).toISOString()}"
            }]    
          }
        `}
        </script>
      )}

      <script type="application/ld+json">
      {`
        {      
          "@context":"https://schema.org",
          "@type": "WebPage",
          "@id": "${pageUrl ? pageUrl : ""}",
          "name": "${!IsEmpty(props.title) ? escapeDoubleQuotes(props.title) : MetaContent.home.title}",
          "url": "${pageUrl ? pageUrl : ""}",
          "description":"${!IsEmpty(props.customDescription)
            ? escapeDoubleQuotes(props.customDescription)
            : MetaContent.home.description}",
          "inLanguage":"en",
          "publisher":{
            "@type":"NewsMediaOrganization",
            "name":"ausbiz",
            "description": "${MetaContent.home.description}",
            "logo":"https://images.squarespace-cdn.com/content/v1/5e5091548bf5a551ea5d9dea/1582338795914-L4KPLRPXI13617OWE4T9/Logo%26Mark_White_Transparent%401x+%281%29.png",
            "foundingDate":"2019-01-01",
            "url":"https://ausbiz.com.au/",
            "sameAs":[
              "https://www.twitter.com/ausbiztv",
              "https://www.facebook.com/711458752615326",
              "https://www.linkedin.com/company/ausbiztv/",
              "https://www.youtube.com/@ausbizTV"
            ]
          },
          "isPartOf":{
            "@type":"WebSite",
            "name":"ausbiz",
            "url":"https://ausbiz.com.au/"         
          }
        }
      `}
      </script>

      {props.structuredData &&(
        <script type="application/ld+json">
          {props.structuredData}
        </script>
      )}

      {props.topicJsonLd && (
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement":
            [
              {
                "@type": "ListItem",
                "position": 1,
                "item": {
                    "@id": "${getEnv("BASE_URL")}",
                    "name": "Home"
                  }
              }
              ${props.topicJsonLdObject ? ',' : ''}
              ${props.topicJsonLdObject && props.topicJsonLdObject.map((nav, index) => {
              return (
                `{
                  "@type": "ListItem",
                  "position": ${index + 2},
                  "item":
                  {
                    "@id": "${getEnv("BASE_URL")}/topic${nav.tierInUrl}?topicID=${nav.id}",
                    "name": "${nav.name}"
                  }
                }`
              );}).join(',')}
            ]
        }`}
      </script>
      )}
      {props.transcriptData &&
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "url": "${pageUrl ? pageUrl : ""}",
            "headline": "${escapeDoubleQuotes(props.title)}",
            "mainEntityOfPage": "${pageUrl ? pageUrl : ""}",
            "articleBody": "${escapeDoubleQuotes(props.transcriptData)}",
            "author": {
              "@type":"NewsMediaOrganization",
              "name":"ausbiz",
              "description": "${escapeDoubleQuotes(MetaContent.home.description)}",
              "logo":"https://images.squarespace-cdn.com/content/v1/5e5091548bf5a551ea5d9dea/1582338795914-L4KPLRPXI13617OWE4T9/Logo%26Mark_White_Transparent%401x+%281%29.png",
              "foundingDate":"2019-01-01",
              "url":"https://ausbiz.com.au/",
              "sameAs":[
                "https://www.twitter.com/ausbiztv",
                "https://www.facebook.com/711458752615326",
                "https://www.linkedin.com/company/ausbiztv/",
                "https://www.youtube.com/@ausbizTV"
              ]
            }
          }
        `}</script>
      }
      {!IsEmpty(props.token) && (
        <script>{`{ 
        var beamer_config = {
        "product_id" : '${getEnv("BEAMER_PRODUCT_ID")}', //DO NOT CHANGE: This is your product code on Beamer
          "selector" : 'callBeamer',
          "display" : 'right', 
          //mobile : true, /*Optional : false if you don't want to initialize Beamer on mobile devices*/
          //---------------Visitor Information---------------
          "user_firstname" : "${props?.userProfile?.firstName}", 
          "user_lastname" : "${props?.userProfile?.lastName}", 
          "user_email" : "${props?.userProfile?.email}",
          "user_id" : "${props?.userProfile?.id}"
        }}`}

        </script>
      )}
      {!IsEmpty(props.token) && (
        <script type="text/javascript" src="https://app.getbeamer.com/js/beamer-embed.js" defer="defer"></script>
      )}
      <script type="text/javascript" id="dianomi_context_script" src="https://www.dianomi.com/js/contextfeed.js"></script>
    </Helmet>
  );
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.auth.userProfile,
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, null)(HelmetStructure);

